module.exports = __webpack_public_path__ + "static/media/Pic 3.2a637170.jpeg";